var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appConfig.page_custom_index_image)?[_c('img',{staticClass:"cm-img",attrs:{"src":_vm.appConfig.page_custom_index_image,"alt":""}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }